import React, { FC, Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ButtonClose from "shared/ButtonClose/ButtonClose";
import { getUrl } from "functions/BaseAxios";
import Iframe from 'react-iframe'

export interface DocIframeProps {
    baseDoc: string;
    title: string;
    onClose: () => void;
    isOpen: boolean;
    initFocus?: number;
}

const DocIframe: FC<DocIframeProps> = ({
    baseDoc,
    title,
    isOpen,
    onClose,
}) => {
    const [activeLang, setActiveLang] = useState("id");

    const renderDocIframe = () => {
        let url = getUrl(`${baseDoc}_${activeLang}.pdf`);
        if (baseDoc.includes('cancelation')) {
            url = getUrl(`${baseDoc}.pdf`);
        }
        return (
            <Transition
                appear
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
                show={isOpen}
                as={Fragment}
            >
                <Dialog
                    as="div"
                    className="fixed inset-0 z-50 overflow-y-auto"
                    onClose={() => console.log("")}
                >
                    <div className="h-5/6 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0 bg-white dark:bg-neutral-800" />
                        </Transition.Child>
                        <div className="absolute left-2 top-2 md:top-4 md:left-4">
                            <ButtonClose className=" w-11 h-11" onClick={onClose} />
                        </div>
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>

                        <div className="relative inline-block w-full  h-full max-w-5xl my-8 align-middle justify-center ">
                            <div className="flex flex-row justify-between mb-4">
                                <div className="flex-1">
                                    <h4 className="text-lg text-left font-semibold">{title}</h4>
                                </div>
                                {baseDoc.includes('cancelation') ? <></> : (
                                    <div className="flex-row ">
                                    <button
                                        onClick={() => setActiveLang('en')}
                                        className={`mr-4 p-2 ${activeLang === 'en' ? 'bg-primary-6000 text-white' : ''}`}>
                                        EN
                                    </button>
                                    <button
                                        onClick={() => setActiveLang('id')}
                                        className={`mr-4 p-2 ${activeLang === 'id' ? 'bg-primary-6000 text-white' : ''}`}>
                                        ID
                                    </button>

                                </div>
                                )}
                                
                            </div>
                            <Iframe url={url}
                            // <Iframe url={getUrl(`${baseDoc}_${activeLang}.pdf`)}
                                width="450px"
                                height="450px"
                                id="myId"
                                className="w-full h-full"
                                position="relative" />

                        </div>
                    </div>
                </Dialog>
            </Transition>
        );
    };

    return renderDocIframe();
};

export default DocIframe;
